@if (tabProps$ | async; as obj) {
    <div class="betslip-edit-state-tabs-and-picks">
        <bs-digital-balance-header [inColumn]="inColumn" />
        <div *ngIf="isUserOnPlayBreak || (hasArcPreBetMessage$ | async)" [ngClass]="{ 'arc-betslip-message': !isUserOnPlayBreak }">
            <ms-arc-message [profileData]="(profileData$ | async) ?? undefined" [featureLocation]="featureLocation.PreBetSlipMessage" />
        </div>
        <div class="betslip-edit-state__scroller">
            <div class="betslip-edit-state-container" *ngIf="!(hasOnboarding$ | async); else onboarding">
                <div class="betslip-edit-state__slips-content">
                    <bs-betslip-linear-type-list
                        class="betslip-edit-state__type-list betslip-scroller"
                        [obj]="obj"
                        [oddsDisplayFormat]="oddsDisplayFormat"
                        [scrollerMinHeight]="scrollerMinHeight" />

                    <ng-container *ngIf="isSettingsOpened$ | async">
                        <bs-digital-settings (settingsOpened)="onSettingsOpened($event)" />
                        <div class="betslip-edit-state__settings-overlay"></div>
                    </ng-container>
                </div>
                <bs-quick-deposit
                    *ngIf="isQuickDepositOpen$ | async"
                    [inColumn]="inColumn"
                    [keepOpen]="(isButtonProcessing$ | async) ?? false"
                    [trackingSource]="quickDepositSource" />
                <bs-digital-summary
                    *ngIf="!(isOveraskOpened$ | async)"
                    [ngClass]="{ 'betslip-summary--settings-opened': isSettingsOpened$ | async }"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [isQuickDepositOpen]="(isQuickDepositOpen$ | async) ?? false" />
                <bs-digital-place-button />
            </div>
        </div>
    </div>
    <ng-template #onboarding>
        <bs-onboarding />
    </ng-template>
}
